import { candidatesCountColumn } from './columns/candidates-count-column';
import { closedAtColumn } from './columns/closed-at-column';
import { createdAtColumn } from './columns/created-at-column';
import { departmentColumn } from './columns/department-column';
import { disqualifiedCountColumn } from './columns/disqualified-count-column';
import { eeoColumn } from './columns/eeo-column';
import { followersColumn } from './columns/followers-column';
import { hiredCountColumn } from './columns/hired-count-column';
import { hiringManagerColumn } from './columns/hiring-manager-column';
import { jobGuidColumn } from './columns/job-guid-column';
import { languagesColumn } from './columns/languages-column';
import { locationColumn } from './columns/location-column';
import { locationNameColumn } from './columns/location-name-column';
import { manageColumn } from './columns/manage-column';
import { newCandidatesCountColumn } from './columns/new-candidates-count-column';
import { priorityColumn } from './columns/priority-column';
import { publishedAtColumn } from './columns/published-at-column';
import { qualifiedCountColumn } from './columns/qualified-count-column';
import { recruiterColumn } from './columns/recruiter-column';
import { requisitionsColumn } from './columns/requisitions-column';
import { scheduledCloseColumn } from './columns/scheduled-close-column';
import { scheduledPublishColumn } from './columns/scheduled-publish-column';
import { tagsColumn } from './columns/tags-column';
import { titleColumn } from './columns/title-column';
import { workModelColumn } from './columns/work-model-column';

export type OfferTableFields =
  | 'candidates'
  | 'date_close'
  | 'date_created'
  | 'date_publish'
  | 'department'
  | 'disqualified_candidates'
  | 'followers'
  | 'hires'
  | 'hiring_manager'
  | 'job_id'
  | 'location'
  | 'location_name'
  | 'manage'
  | 'new_candidates'
  | 'qualified_candidates'
  | 'recruiter'
  | 'requisitions'
  | 'scheduled_close_date'
  | 'scheduled_publish_date'
  | 'state_region'
  | 'status'
  | 'tags'
  | 'languages'
  | 'title'
  | 'work_model'
  | 'priority'
  | 'eeo_compliance';

export const offerColumns = [
  titleColumn,
  tagsColumn,
  candidatesCountColumn,
  publishedAtColumn,
  createdAtColumn,
  closedAtColumn,
  followersColumn,
  recruiterColumn,
  hiringManagerColumn,
  newCandidatesCountColumn,
  languagesColumn,
  scheduledPublishColumn,
  scheduledCloseColumn,
  eeoColumn,
  jobGuidColumn,
  hiredCountColumn,
  departmentColumn,
  locationColumn,
  locationNameColumn,
  qualifiedCountColumn,
  disqualifiedCountColumn,
  requisitionsColumn,
  manageColumn,
  workModelColumn,
  priorityColumn,
];

export enum OfferColumnId {
  Title = 'title',
  CandidatesCount = 'candidatesCount',
  NewCandidatesCount = 'newCandidatesCount',
  HiredCandidatesCount = 'hiredCandidatesCount',
  DisqualifiedCount = 'disqualifiedCandidatesCount',
  QualifiedCount = 'qualifiedCandidatesCount',
  Department = 'department',
  LocationAddress = 'location',
  LocationName = 'locationName',
  Languages = 'languages',
  ScheduledPublish = 'publishDate',
  ScheduledClose = 'closeDate',
  PublishedAt = 'publishedAt',
  ClosedAt = 'closedAt',
  TeamMembers = 'teamMembers',
  Tags = 'offerTags',
  CreatedAt = 'createdAt',
  OpenTime = 'openTime',
  Manage = 'manage',
  Followers = 'followers',
  Eeo = 'eeo',
  Recruiter = 'recruiter',
  HiringManager = 'hiring_manager',
  JobGuid = 'job_guid',
  Requisitions = 'requisitions',
  WorkModel = 'work_model',
  Priority = 'priority',
}

export const offerColumnFieldMap: Partial<Record<OfferColumnId, OfferTableFields>> = {
  [OfferColumnId.CandidatesCount]: 'candidates',
  [OfferColumnId.ClosedAt]: 'date_close',
  [OfferColumnId.CreatedAt]: 'date_created',
  [OfferColumnId.PublishedAt]: 'date_publish',
  [OfferColumnId.Department]: 'department',
  [OfferColumnId.DisqualifiedCount]: 'disqualified_candidates',
  [OfferColumnId.Followers]: 'followers',
  [OfferColumnId.HiredCandidatesCount]: 'hires',
  [OfferColumnId.HiringManager]: 'hiring_manager',
  [OfferColumnId.JobGuid]: 'job_id',
  [OfferColumnId.LocationAddress]: 'location',
  [OfferColumnId.LocationName]: 'location_name',
  [OfferColumnId.Manage]: 'manage',
  [OfferColumnId.NewCandidatesCount]: 'new_candidates',
  [OfferColumnId.QualifiedCount]: 'qualified_candidates',
  [OfferColumnId.Recruiter]: 'recruiter',
  [OfferColumnId.Requisitions]: 'requisitions',
  [OfferColumnId.ScheduledClose]: 'scheduled_close_date',
  [OfferColumnId.ScheduledPublish]: 'scheduled_publish_date',
  [OfferColumnId.Tags]: 'tags',
  [OfferColumnId.Languages]: 'languages',
  [OfferColumnId.Eeo]: 'eeo_compliance',
  [OfferColumnId.Title]: 'title',
  [OfferColumnId.WorkModel]: 'work_model',
  [OfferColumnId.Priority]: 'priority',
};
